module.exports = __webpack_public_path__ + "public/img/code_1.453103c8.jpg";